var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 53,
    viewBox: "0 0 64 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3779 20.7241V36.8296C51.0723 38.6768 48.5869 40.1826 45.9878 41.3477C45.3413 41.6377 44.688 41.9067 44.0283 42.1548C38.876 44.0894 33.3589 44.7368 27.9634 44.0972C21.7798 43.3643 15.7563 40.9414 10.623 36.8296V20.7241H53.3779Z",
    fill: "#545D68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.106 20.7248V42.5578C17.3823 41.3078 13.8296 39.3981 10.623 36.8303V20.7248H21.106Z",
    fill: "#3B454F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9878 24.1359V41.3478C45.3413 41.6379 44.688 41.9069 44.0283 42.155V24.1359C44.0283 23.4733 44.4673 22.9352 45.0083 22.9352C45.5488 22.9352 45.9878 23.4733 45.9878 24.1359Z",
    fill: "#3B454F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3779 20.7243V22.0305L32.0005 30.1804L10.623 22.0305V20.7243H53.3779Z",
    fill: "#3B454F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64 12.2002V16.6738L32 28.874L0 16.6738V12.2002L32 0L64 12.2002Z",
    fill: "#545D68"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24.4009V28.874L0 16.6738V12.2002L32 24.4009Z",
    fill: "#3B454F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4405 47.5196C47.8994 47.5196 47.461 47.0806 47.461 46.5396V18.7647L31.5957 11.5811C31.1031 11.3579 30.8843 10.7774 31.1075 10.2842C31.3306 9.79153 31.9107 9.57278 32.4043 9.79593L48.8448 17.2403C49.1953 17.399 49.42 17.7481 49.42 18.1324V46.5396C49.42 47.0806 48.9815 47.5196 48.4405 47.5196Z",
    fill: "#0747A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1836 49.2827C51.1836 50.7974 49.9556 52.0254 48.4409 52.0254C46.9258 52.0254 45.6978 50.7974 45.6978 49.2827C45.6978 47.7676 46.9258 46.5396 48.4409 46.5396C49.9556 46.5396 51.1836 47.7676 51.1836 49.2827Z",
    fill: "#F7D360"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.ebda0246.svg";
export { ForwardRef as ReactComponent };